import { render, staticRenderFns } from "./addRemark.vue?vue&type=template&id=12787dd9&scoped=true"
import script from "./addRemark.vue?vue&type=script&lang=js"
export * from "./addRemark.vue?vue&type=script&lang=js"
import style0 from "./addRemark.vue?vue&type=style&index=0&id=12787dd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12787dd9",
  null
  
)

export default component.exports